"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowRightLine = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowRightLine"));

// Generated by script, don't edit it please.
var ArrowRightLine = (0, _createSvgIcon["default"])({
  as: _ArrowRightLine["default"],
  ariaLabel: 'arrow right line',
  category: 'direction',
  displayName: 'ArrowRightLine'
});
var _default = ArrowRightLine;
exports["default"] = _default;
module.exports = exports.default;